module.exports = __webpack_public_path__ + "img/inter-milan.6dc9a775.png";